import React from "react";

import {
	TabsContentContainer,
	TableContainer,
	FilterContainer,
	Filters,
	ActionsContainer,
} from "components";
import { signedMPAFilterInitialValues } from "models";
import { applicationListService } from "services";

import ApplicationsActions from "../applicationsActions";
import ApplicationsTable from "../applicationsTable";
import * as filter from "../filterColumns";
import * as table from "../tableColumns";

const filterColumns = [
	filter.applicationIdColumn(),
	filter.merchantNameColumn(),
	filter.processorColumn(),
	filter.sponsorColumn(),
	filter.agentOfficeColumn(),
	filter.agentNameColumn(),
	filter.assignedToColumn(),
];

const tableColumns = [
	table.nailSoftColumn(),
	table.applicationIdColumn(),
	table.merchantNameColumn(),
	table.proseccorSponsorColumn(),
	table.agentOfficeAgentNameColumn(),
	table.applicationStatusColumn(),
	table.ageInApplicationColumn(),
	table.ageInStatusColumn(),
	table.assignedToColumn(),
	table.applicationListActionsColumn({
		showInlineEditButton: true,
		showRemoveButton: true,
	}),
];

const form = "applicationsFiltersSignedMPAs";

const SignedMPAsTab = () => {
	return (
		<TabsContentContainer className="container-flex">
			<FilterContainer>
				<Filters
					form={form}
					columns={filterColumns}
					initialValues={signedMPAFilterInitialValues}
				/>
			</FilterContainer>
			<ActionsContainer className="m-0">
				<ApplicationsActions />
			</ActionsContainer>
			<TableContainer>
				<ApplicationsTable
					getList={applicationListService.getSignedMPAs}
					columns={tableColumns}
					form={form}
				/>
			</TableContainer>
		</TabsContentContainer>
	);
};

export default SignedMPAsTab;
